import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/components/ui/use-toast";

export const updateMatch = async (
  id: string,
  updatedData: Record<string, any> = {},
  customFields: Record<string, any> = {}
): Promise<boolean> => {
  if (!id) return false;

  try {
    // Only include fields that exist in the database table
    const dataToUpdate: Record<string, any> = { ...updatedData };
    if (customFields && Object.keys(customFields).length > 0) {
      dataToUpdate.custom_fields = customFields;
    }

    const { error } = await supabase
      .from('matches')
      .update(dataToUpdate)
      .eq('id', id);

    if (error) {
      console.error("Error updating match:", error);
      toast({
        title: "Error",
        description: `Failed to update match: ${error.message}`,
        variant: "destructive"
      });
      throw error;
    }

    toast({
      title: "Success",
      description: "Match updated successfully"
    });
    return true;
  } catch (error) {
    console.error("Error updating match:", error);
    return false;
  }
}; 